/**
 * Created by Stefano Mandruzzato on 21/11/18.
 */
import angular from 'angular';
import 'angular-translate';

export class EmailService {

    constructor($log, ) {
        'ngInject';
        this._logger = $log.getInstance('EmailService');
        this.emailUser = "";
        this.emailDomain = "";
        this.accessType = "";
        this.username = "";
        this.personalizationId = "";
        this.warning = "";
    }

    $onInit() {

    }

    setEmailUser(emailUser) {
        this._logger.debug("setEmailUser", emailUser);
        this.emailUser = emailUser;
    }

    getEmailUser() {
        return this.emailUser;
    }

    setAccessType(accessType) {
        this._logger.debug("setAccessType", accessType);
        this.accessType = accessType;
    }

    getAccessType() {
        return this.accessType;
    }

    setEmailDomain(emailDomain) {
        this._logger.debug("setEmailDomain", emailDomain);
        this.emailDomain = emailDomain;
    }

    setUsername(username) {
        this._logger.debug("setUsername", username);
        this.username = username;
    }

    getUsername() {
        return this.username;
    }

    setPersonalizationId(personalizationId) {
        this._logger.debug("setPersonalizationId", personalizationId);
        this.personalizationId = personalizationId;
    }

    getPersonalizationId() {
        return this.personalizationId;
    }

    getEmailDomain() {
        return this.emailDomain;
    }

    setWarning(warning) {
        this._logger.debug("setWarning", warning);
        this.warning = warning;
    }

    getWarning() {
        return this.warning;
    }

}

export default angular.module('lmrcApp.email-service', [])
    .service('EmailService', EmailService)
    .name;


// WEBPACK FOOTER //
// ./client/components/email-service/index.js